import React, { useState } from 'react'
import Select from 'react-select'

// const options = [
//   { label: 'Part 1: The global picture', value: 'part1' },
//   { label: 'Regional overviews', value: 'regions' },
//   {
//     label: 'Part 2: Children and youth in internal displacement',
//     value: 'part2',

//   }
// ]

const CountryDropDown = ({ options, selectType = "all"    }) => {

   const countries_details = {
    AFG: {
       "Country":"Afghanistan"
      ,"url":"/countries/afghanistan"
      },
    AGO: {
       "Country":"Angola"
      ,"url":"/countries/angola"
      },
    AUS: {
       "Country":"Australia"
      ,"url":"/countries/australia"
      },
    BGD: {
       "Country":"Bangladesh"
      ,"url":"/countries/bangladesh"
      },
    BRA: {
       "Country":"Brazil"
      ,"url":"/countries/brazil"
      },
    BFA: {
       "Country":"Burkina Faso"
      ,"url":"/countries/burkina-faso"
      },
    BDI: {
       "Country":"Burundi"
      ,"url":"/countries/burundi"
      },
    CMR: {
       "Country":"Cameroon"
      ,"url":"/countries/cameroon"
      },
    CAN: {
       "Country":"Canada"
      ,"url":"/countries/canada"
      },
    CAF: {
       "Country":"Central African Rep."
      ,"url":"/countries/central-african-republic"
      },
    TCD: {
       "Country":"Chad"
      ,"url":"/countries/chad"
      },
    CHN: {
       "Country":"China"
      ,"url":"/countries/china"
      },
    COL: {
       "Country":"Colombia"
      ,"url":"/countries/colombia"
      },
    CUB: {
       "Country":"Cuba"
      ,"url":"/countries/cuba"
      },
    COD: {
       "Country":"Dem. Rep. Congo"
      ,"url":"/countries/democratic-republic-of-the-congo"
      },
    SLV: {
       "Country":"El Salvador"
      ,"url":"/countries/el-salvador"
      },
    ETH: {
       "Country":"Ethiopia"
      ,"url":"/countries/ethiopia"
      },
    GRC: {
       "Country":"Greece"
      ,"url":"/countries/greece"
      },
    HTI: {
       "Country":"Haiti"
      ,"url":"/countries/haiti"
      },
    IND: {
       "Country":"India"
      ,"url":"/countries/india"
      },
    IDN: {
       "Country":"Indonesia"
      ,"url":"/countries/indonesia"
      },
    IRN: {
       "Country":"Iran"
      ,"url":"/countries/iran"
      },
    IRQ: {
       "Country":"Iraq"
      ,"url":"/countries/iraq"
      },
    KEN: {
       "Country":"Kenya"
      ,"url":"/countries/kenya"
      },
    KGZ: {
       "Country":"Kyrgyztan"
      ,"url":"/countries/kyrgyzstan"
      },
    MYS: {
       "Country":"Malaysia"
      ,"url":"/countries/malaysia"
      },
    MLI: {
       "Country":"Mali"
      ,"url":"/countries/mexico"
      },
    MEX: {
       "Country":"Mexico"
      ,"url":"/countries/malaysia"
      },
    MOZ: {
       "Country":"Mozambique"
      ,"url":"/countries/mozambique"
      },
    MMR: {
       "Country":"Myanmar"
      ,"url":"/countries/myanmar"
      },
    NPL: {
       "Country":"Nepal"
      ,"url":"/countries/nepal"
      },
      NLD: {
        "Country":"Netherlands"
       ,"url":"/countries/netherlands"
       },
    NLD: {
       "Country":"Netherlands"
      ,"url":"/countries/netherlands"
      },
    NER: {
       "Country":"Niger"
      ,"url":"/countries/niger"
      },
    NGA: {
       "Country":"Nigeria"
      ,"url":"/countries/nigeria"
      },
    PAK: {
       "Country":"Pakistan"
      ,"url":"/countries/pakistan"
      },
    PSE: {
       "Country":"Palestine"
      ,"url":"/countries/palestine"
      },
    PHL: {
       "Country":"Philippines"
      ,"url":"/countries/philippines"
      },
    SOM: {
       "Country":"Somalia"
      ,"url":"/countries/somalia"
      },
    SSD: {
       "Country":"South Sudan"
      ,"url":"/countries/south-sudan"
      },
    LKA: {
       "Country":"Sri Lanka"
      ,"url":"/countries/sri-lanka"
      },
    VCT: {
       "Country":"St. Vincent and the Grenadines"
      ,"url":"/countries/saint-vincent-and-the-grenadines"
      },
    SDN: {
       "Country":"Sudan"
      ,"url":"/countries/sudan"
      },
    SYR: {
       "Country":"Syria"
      ,"url":"/countries/syria"
      },
    TZA: {
       "Country":"Tanzania"
      ,"url":"/countries/tanzania"
      },
    TUR: {
       "Country":"Türkiye"
      ,"url":"/countries/turkey"
      },
    UGA: {
       "Country":"Uganda"
      ,"url":"/countries/uganda"
      },
    USA: {
       "Country":"United States"
      ,"url":"/countries/united-states"
      },
    VEN: {
       "Country":"Venezuela"
      ,"url":"/countries/venezuela"
      },
    VNM: {
       "Country":"Viet Nam"
      ,"url":"/countries/viet-nam"
      },
    YEM: {
       "Country":"Yemen"
      ,"url":"/countries/yemen"
      }
  }


  const [currVal, newVal] = useState(options[0])
  const handleChange = e => {
    if (typeof window !== 'undefined') {
        window.open(
            'https://internal-displacement.org' + e.value,
            '_blank'
          )
      }
    
  }
  let showCountries = []
  
  
  options.forEach((element, index) => {
    showCountries.push(
      {label: countries_details[element]['Country'],
    value: countries_details[element]['url']}
    )
  })

  let doc = ''

  if (typeof document !== 'undefined') {
    doc = document.body
  }
  return (
    <form>
      <Select
        menuPortalTarget={doc}
        menuPosition='fixed'
        options={showCountries}
        placeholder="Select a country..."
        onChange={e => handleChange(e)}
        styles={{
          menuPortal: provided => ({ ...provided, zIndex: 9999 }),
          menu: provided => ({ ...provided, zIndex: 9999 })
        }}
      />
    </form>
  )
}

export default CountryDropDown
